import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ScreenState } from '@src/app/enums';
import { MultiPortfolioPerformanceDetails } from 'clientportalshared';
import { getPerformanceAsync } from './thunks';
import { DateRange } from '../..';
import { DateTime } from 'luxon';
import { DatePickerNames } from '@components/dateRange/DateRangePreDefinedDates';

export interface PerformanceStore {
  state: ScreenState;
  data: MultiPortfolioPerformanceDetails;
  dateRange: DateRange;
}

const initialState: PerformanceStore = {
  state: ScreenState.Loading,
  data: {},
  dateRange: {
    dateFrom: DateTime.now().minus({ months: 12 }).toISODate(),
    dateTo: DateTime.now().toISODate(),
    dateRangeType: DatePickerNames.Last12Months,
  },
};

export const PerformanceSlice = createSlice({
  name: 'performance',
  initialState,
  reducers: {
    setPerformanceDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getPerformanceAsync.pending, (state) => {
      state.state = ScreenState.Loading;
    });
    builder.addCase(getPerformanceAsync.rejected, (state) => {
      state.state = ScreenState.ErrorUnableToLoadData;
    });
    builder.addCase(getPerformanceAsync.fulfilled, (state, action) => {
      state.data = action.payload;
      state.state = ScreenState.SuccessDataLoaded;
    });
  },
});

export const { setPerformanceDateRange } = PerformanceSlice.actions;

export default PerformanceSlice.reducer;
